export default {
    "width": 29,
    "height": 29,
    "sprites": [
        //transparent sky
        {
            "name": "transparent",
            "x": 155,
            "y": 165
        },
        // {
        //     "name": "sky",
        //     "x": 510,
        //     "y": 570
        // },
        {
            "name": "groundTop",
            "x": 445,
            "y": 202
        },
        {
            "name": "groundSoil",
            "x": 445,
            "y": 220
        },
        {
            "name": "groundMidLeftEdge",
            "x": 427,
            "y": 220
        },
        {
            "name": "groundMidRightEdge",
            "x": 462,
            "y": 220
        },
        {
            "name": "groundTopRightEdge",
            "x": 462,
            "y": 202
        },
        {
            "name": "groundTopLeftEdge",
            "x": 427,
            "y": 202
        },
        {
            "name": "groundTopRightPatch",
            "x": 358,
            "y": 383
        },
        {
            "name": "groundTopLeftPatch",
            "x": 374.5,
            "y": 382.5
        },
        {
            "name": "groundTopFloatingLeft",
            "x": 427,
            "y": 253
        },
        {
            "name": "groundTopFloatingRight",
            "x": 462,
            "y": 253
        },
        {
            "name": "groundTopFloatingRightSoil",
            "x": 462,
            "y": 271
        },
        {
            "name": "groundTopFloatingLeftSoil",
            "x": 427,
            "y": 271
        },
        {
            "name": "platformLeft",
            "x": 37.5,
            "y": 1
        },
        {
            "name": "platformMiddle",
            "x": 55,
            "y": 1
        },
        {
            "name": "platformRight",
            "x": 72.5,
            "y": 1
        },
        {
            "name": "mysteryBox1",
            "x": 173.3,
            "y": 181.3
        },
        {
            "name": "mysteryBox2",
            "x": 190.3,
            "y": 181.3
        },
        {
            "name": "mysteryBox3",
            "x": 207.3,
            "y": 181.3
        },
        {
            "name": "mysteryBox4",
            "x": 224.3,
            "y": 181.3
        },
        {
            "name": "grass1",
            "x": 90,
            "y": 464
        },
        {
            "name": "grass2",
            "x": 124,
            "y": 464
        },
        {
            "name": "grass3",
            "x": 158,
            "y": 464
        },
        {
            "name": "grass4",
            "x": 192,
            "y": 464
        },
        {
            "name": "singlePlatform",
            "x": 173.5,
            "y": 164
        },
        // {
        //     "name": "happyCloud",
        //     "x": 257.8,
        //     "y": 13.8
        // },
        {
            "name": "mushroom",
            "x": 292,
            "y": 30
        }
    ]
}